import {
	logIn,
	emailLogin,
	passwordLogin,
	checkLoginType,
	forgotVerification,
	EMAIL_SUCCESS_MESSAGE,
} from '../../../api';
import { onRequest } from '../..';
import { getUrlParam, PropertyType, ActionsType } from '../../../common';

type LoginType = (rs: PropertyType) => void;

const loginSubmit = async (state: PropertyType, login: LoginType) => {
	const { email, password, two_step_code } = state;
	const token = getUrlParam('token');
	const res = await logIn(email && password ? { email, password, two_step_code } : { token });

	if (res?.token) {
		login(res);
	} else {
		return { errors: [], success: EMAIL_SUCCESS_MESSAGE };
	}
};

const emailSubmit = async (state: PropertyType, payload: PropertyType) => {
	const { loginType } = payload;
	const { email } = state;
	const success = await emailLogin(email, loginType);

	return { errors: [], success };
};

const forgotSubmit = async (state: PropertyType) => {
	const { email, two_step_code } = state;
	const success = await forgotVerification({ email, two_step_code });

	return { errors: [], success };
};

const onCheckLoginType = async () => {
	const type = await checkLoginType();

	return { loginType: type };
};

const passwordSubmit = async (state: PropertyType, payload: PropertyType) => {
	const { login, loginType } = payload;
	const { password, two_step_code } = state;
	const token = getUrlParam('token');
	const email = getUrlParam('email');
	const res = await passwordLogin({ token, email, password, two_step_code }, loginType);

	login(res);
};

export const actions: ActionsType = {
	EMAIL: (state, payload) => ({ email: payload }),
	EMAIL_INVALID: (state, payload) => ({ emailInvalid: payload }),
	PASS: (state, payload) => ({ password: payload }),
	TWO_STEP_CODE: (state, payload) => ({ two_step_code: payload }),
	TWO_STEP: (state, payload) => ({ two_step_code: payload }),
	ERROR: (state, payload) => ({ errors: payload }),
	SUCCESS: (state, payload) => ({ success: payload }),
	LOGIN_SUBMIT: (state, payload) => onRequest(() => loginSubmit(state, payload)),
	EMAIL_SUBMIT: (state, payload) => onRequest(() => emailSubmit(state, payload)),
	FORGOT_SUBMIT: (state) => onRequest(() => forgotSubmit(state)),
	PASS_SUBMIT: (state, payload) => onRequest(() => passwordSubmit(state, payload)),
	LOGIN_TYPE: () => () => onCheckLoginType(),
	MESSAGE_INVALIDATE: () => ({ errors: [], success: '' }),
};
